var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M14.247 16.602l-1.33-1.572a6.5 6.5 0 1 1 2.113-2.113l1.588 1.344c.014.01.028.022.041.035l2.464 2.085a1.946 1.946 0 1 1-2.742 2.742l-2.01-2.376a.506.506 0 0 1-.124-.145zm.467-.997l.872-.907-1.148-.971a6.54 6.54 0 0 1-.711.711l.987 1.167zm.65.767l1.78 2.105a.946.946 0 1 0 1.333-1.333l-2.126-1.799-.988 1.027zM9.5 15a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z" })
  );
});